/*******************************************************************************
* Project: SMTM_EXM
* Summary:
*    Define PostalCodeFormat
* History:
*    ThaiTV            2022/01/02    Create
******************************************************************************/

import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from '../shared/utility/utility';
@Pipe({ name: 'postalCodeFormat' })
export class PostalCodeFormat implements PipeTransform {
    regHaftWidth = /^[0-9]*$/;
    constructor(
        public ulti: Utility,
    ) { }
    transform(pStrCode: string): string {
        try {
            if (!this.ulti.isNullOrEmpty(pStrCode)) {
                /* 20250208 #18640 modify start */
                // if (pStrCode.length > 3) {
                if (pStrCode.length == 7) {
                /* 20250208 #18640 modify end */
                    const postVal = pStrCode.replace(/\s/g, '');
                    pStrCode = postVal.substring(0, 3) + '-' + postVal.substring(3);
                }
                return pStrCode;
            } else {
                return '';
            }
        } catch (err) {
            return '';
        }
    }
    showForm(value: string) {
        return this.ulti.setAreaNumber(value);
    }
}
